import {IFilterChoices} from "./models";
import Immutable = require('immutable');
import {IChoice} from "./models";
import {IConfiguration} from "./models";
import {DetailsFormData} from "./models";
import {AddressFormData} from "./models";
import {IQuestion} from "./models";

/**
 * Filters the given choices to the ones that are valid for the given user choices
 */
export function filterChoices(allChoices:IFilterChoices, userChoices:string[]):IFilterChoices {

    var choices = Immutable.Map(allChoices);

    Immutable.List(userChoices).map((userChoice, index) => {
        choices = choices.filter((choices, filter) => {
            var parts = filter.split("/").filter(x => x.length > 0);
            return parts[index] == userChoice || parts[index] == '*';
        }).toMap();
    });

    return choices.toJS();
}

/**
 * Returns the most specific out of all the choices (less amount of * in it)
 */
export function getMostSpecific(choices:IFilterChoices) : Array<IChoice|string> {

    var countSpecific = (filter:string) => Immutable.List(filter.split("/")).filterNot(x => x == '*').count();

    return Immutable.Map(choices)
        .map((choices, filter) => {
                return [choices, filter, countSpecific(filter)]
            }
        )
        .toList()
        .sortBy(x => x[2])
        .last()[0] as any;
}

export function getChoiceName(choice: IChoice|string) : string {
    if (typeof choice === "string") {
        return choice
    }
    return choice.altName || choice.name
}

export function getChoiceValue(choice: IChoice|string) : string {
    if (typeof choice === "string") {
        return choice
    }
    return choice.name
}

export function getModelChoice(brand: string, model: string) {
    switch(brand) {
        case 'iPad': {
            return model
        }
        case 'Samsung Phone': {
            return `Samsung Galaxy ${model}`
        }
        default: {
            return `${brand} ${model}`
        }
    }
}

/** Filters the given configurations based on the given user choices */
export function filterConfigurations(configurations: IConfiguration[], userChoices: string[], howManyChoicesToConsider = 4) {
    return configurations.filter( entry => {
        return userChoices.slice(0, howManyChoicesToConsider).every( (uc,index) => entry.configuration[index] == uc );
    });
}

/** Get the choices to display to the user for each question */
export function getChoices(configurations: IConfiguration[], questionIndex: number) : string[] {

    // Note: We are intentionally building the results array by iterating through all the options so that
    // we preserve the order that the choices appear even though it's not the most efficient calculation

    var result = [];

    configurations.forEach(config => {
        var choice = config.configuration[questionIndex];

        if (choice && result.indexOf(choice) < 0) {
            result.push(choice)
        }
    });

    return result;
}

export function getTicketText(userChoices: string[], questions: IQuestion[], details: DetailsFormData, address: AddressFormData, quote: number) : string {

    var getSpace = (key: string) : string => Immutable.Range(key.length, 20).map(x => ".").join('');

    var choicesText = Immutable.List(userChoices).map( (choice, index) => {
        return questions[index].name + ":" + getSpace(questions[index].name) + choice;
    }).join("\n");

    var detailsText = "Personal Details:\n" + Immutable.Map(details)
            .map( (v:string,k:string) => k + ":" + getSpace(k) + v)
            .join("\n");

    var quoteText = "Quote: " + quote;

    var addressText = "Address:\n" + Immutable.Map(address)
            .map( (v:string,k:string) => k + ":" + getSpace(k) + v)
            .join("\n");

    return [choicesText, detailsText, quoteText, addressText].join("\n\n");
}

export function userChoicesAsDictionary(userChoices: string[], questions: IQuestion[]) : Dictionary<string> {
    return Immutable.List( userChoices)
        .map( (v,i) => [i,v] )
        .reduce( (map, obj: any) => map.set(questions[obj[0]].name, obj[1]), Immutable.Map() )
        .toJS();
}

export function getUniqueArray<T>(array: T[]): T[] {
    return array.filter((v, i, a) => a.indexOf(v) === i)
}

// rewrite of https://tc39.github.io/ecma262/#sec-array.prototype.find
export function find<T>(array: T[], test: (x : T) => boolean): T {
    // 1. Let O be ? ToObject(this value).
    if (array == null) {
        throw new TypeError('"this" is null or not defined');
    }

    const o = Object(array);

    // 2. Let len be ? ToLength(? Get(O, "length")).
    const len = o.length >>> 0;

    // 3. If IsCallable(predicate) is false, throw a TypeError exception.
    if (typeof test !== 'function') {
        throw new TypeError('predicate must be a function');
    }

    // step 4 skipped
    // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.

    // 5. Let k be 0.
    let k = 0;

    // 6. Repeat, while k < len
    while (k < len) {
        // a. Let Pk be ! ToString(k).
        // b. Let kValue be ? Get(O, Pk).
        // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
        // d. If testResult is true, return kValue.
        let kValue = o[k];
        if (test.call(array, kValue, k, o)) {
            return kValue;
        }
        // e. Increase k by 1.
        k++;
    }

    // 7. Return undefined.
    return undefined;
}

export type PostStatus = string;

export class AsyncPostStatus {
    static NONE : PostStatus = "NONE";
    static POSTING : PostStatus = "POSTING";
    static POSTED : PostStatus = "POSTED";
    static ERROR : PostStatus = "ERROR";
}

export interface AsyncPost<S,R> {
    status: PostStatus              // Post status
    data: S                         // Data to be sent to the server
    responseData?: R                // Response data (usually in json format)
    error?: string|Object           // Error string returned from server or json object with validation errors
}

export interface Dictionary<V> {
    [key: string] : V
}

export interface Coordinates {
    longitude: number
    latitude:  number
}
